module.exports = __webpack_public_path__ + "img/company18.a28761d6.png";